module.exports = __webpack_public_path__ + "static/media/x-celebrity.ce4dcdd6.svg";